import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';

export const ALL_LANGUAGES_QUERY_KEY = 'allLanguagesList';

export type LanguageItem = {
  bcp47: string;
  id: number;
  is_enabled: boolean;
  is_private: boolean;
  key: string;
  name: string;
  type: number;
};

type LanguagesListResponse = {
  result: LanguageItem[];
  count: number;
  total_results: number;
};

/**
 * Hook to fetch all languages without pagination params dependency.
 * Used for dropdowns/selects where we need the full list.
 */
export const useGetAllLanguages = () => {
  const fetchLanguages = async () => {
    const { data } = await Axios.get<LanguagesListResponse>(
      '/api/v3/admin/languageconfig?offset=0&limit=1000'
    );
    return data;
  };

  return useQuery<LanguagesListResponse, AxiosError<BaseError>>(
    [ALL_LANGUAGES_QUERY_KEY],
    fetchLanguages,
    {
      staleTime: 5 * 60 * 1000,
      useErrorBoundary: false
    }
  );
};
